<div class="flex flex-col p-6 pr-4 pb-4">
  <div class="flex items-center justify-between">
    <div class="flex flex-auto justify-between">
      <div class="flex flex-col">
        <div class="font-bold text-md text-secondary uppercase tracking-wider mr-4 title">
          <ng-container *ngIf="!hideTitle">
            {{ chartDef.title }}
            <a
              [appAuthorize]="NewPermission.REPORTS_BUILDER_VIEW"
              *ngIf="isFromSingleObjectReport"
              matTooltip="Go to Report"
              matTooltipPosition="below"
              [routerLink]="['../../', 'reporting', 'builder', chartDef.reportLayout.id]"
            >
              <mat-icon>open_in_new</mat-icon>
            </a>
          </ng-container>
        </div>
        @if (chartDef?.reportLayout) {
          <div class="text-secondary text-xs">
            Last Updated: {{ chartDef?.reportLayout?.updated_at | date: 'MMM dd, Y h:mm a' }}
          </div>
        }
      </div>
      <div>
        <button
          class="more-menu"
          mat-icon-button
          [matMenuTriggerFor]="moreMenu"
          *ngIf="!(hideEdit && hideRemove && hideRefresh)"
        >
          <mat-icon [svgIcon]="'more_vert'"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button *ngIf="!hideEdit" (click)="edit()" mat-menu-item>
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Edit Chart
          </button>
          <button *ngIf="!hideRefresh" (click)="refresh()" mat-menu-item>
            <mat-icon>refresh</mat-icon>
            Refresh Chart
          </button>
          <button *ngIf="!hideRemove" (click)="remove()" mat-menu-item>
            <mat-icon>cancel</mat-icon>
            Remove Chart
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
<div class="flex flex-col flex-auto chart-container">
  <ng-container *ngIf="chartDef.chart_type == 'bar'">
    <chart-bar
      [chartDef]="chartDef"
      [fillMode]="fillMode"
      [isTimeSeries]="isTimeSeries"
      [height]="height"
      (dataPointSelection)="dataPointSelection.emit($event)"
    ></chart-bar>
  </ng-container>
  <ng-container *ngIf="chartDef.chart_type == 'donut'">
    <chart-donut
      [chartDef]="chartDef"
      [fillMode]="fillMode"
      [height]="height"
      (dataPointSelection)="dataPointSelection.emit($event)"
    ></chart-donut>
  </ng-container>
  <ng-container *ngIf="chartDef.chart_type == 'horizontal-bar'">
    <chart-bar
      [chartDef]="chartDef"
      [fillMode]="fillMode"
      [horizontal]="true"
      [isTimeSeries]="isTimeSeries"
      [height]="height"
      (dataPointSelection)="dataPointSelection.emit($event)"
    ></chart-bar>
  </ng-container>
  <ng-container *ngIf="chartDef.chart_type == 'line'">
    <chart-line
      [chartDef]="chartDef"
      [fillMode]="fillMode"
      [isTimeSeries]="isTimeSeries"
      [height]="height"
      (dataPointSelection)="dataPointSelection.emit($event)"
    ></chart-line>
  </ng-container>
  <ng-container *ngIf="chartDef.chart_type == 'metric'">
    <chart-metric
      [chartDef]="chartDef"
      [fillMode]="fillMode"
      [isTimeSeries]="isTimeSeries"
      [height]="height"
      (dataPointSelection)="dataPointSelection.emit($event)"
    ></chart-metric>
  </ng-container>
  <ng-container *ngIf="chartDef.chart_type == 'table'">
    <chart-table
      [chartDef]="chartDef"
      [fields]="fields"
      [fillMode]="fillMode"
      [isTimeSeries]="isTimeSeries"
      [height]="height"
      [overflowAuto]="overflowAuto"
      (dataPointSelection)="dataPointSelection.emit($event)"
    ></chart-table>
  </ng-container>
</div>
